/* eslint-disable no-console */
import React, { useContext } from 'react';
import '../../UiComponents/SideNav/styles.css';
import { isTouchDevice } from '../../libs/HelperContent';
import { useNavigate } from 'react-router-dom';
import { RiArrowRightSLine } from 'react-icons/ri';
import { useSelector } from 'react-redux';
import Profile from '../../assets/SideNavIcons/Profile.svg';
import ChangePassword from '../../assets/SideNavIcons/Change_Password.svg';
import Language from '../../assets/SideNavIcons/Language.svg';
import SocialMediaIntergration from '../../assets/SideNavIcons/Social_Media_Integration.svg';
import { LanguageContext } from '../../libs/Context';
import { MdDevices, MdEmail } from 'react-icons/md';

const ProfileSettingsNav = () =>
{
	const activePath = window.location.pathname.split('/')[2];
	const naviagte = useNavigate();
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { language } = useContext(LanguageContext);

	const PrflSettOpts = [
		{
			id         : '4',
			linkPath   : '/profile',
			srcPath    : Profile,
			title      : language.profile || 'Profile',
			errSrcPath : 'profile.svg',
			role       : [ 'admin', 'superAdmin', 'employee', 'individual' ]
		},
		{
			id         : '0',
			linkPath   : '/changePassword',
			srcPath    : ChangePassword,
			title      : language.changePassword || 'Change Password',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'admin', 'superAdmin', 'employee', 'individual' ]
		},
		{
			id         : '1',
			linkPath   : '/languages',
			srcPath    : Language,
			title      : language.lang || 'Languages',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'admin', 'superAdmin', 'employee', 'individual' ]

		},
		{
			id         : '3',
			linkPath   : '/socialMediaIntegration',
			srcPath    : SocialMediaIntergration,
			title      : language.socialMediaIntegrtn || 'Social Media Integration',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'admin', 'superAdmin', 'employee' ]
		},
		{
			id            : '5',
			linkPath      : '/deviceManagement',
			srcPath       : null,
			iconComponent : MdDevices,
			title         : language.manageSessions || 'Manage Sessions',
			errSrcPath    : 'devices.svg',
			role          : [ 'admin', 'superAdmin', 'employee', 'individual' ]
		},
		{
			id            : '6',
			linkPath      : '/emailChange',
			srcPath       : null,
			iconComponent : MdEmail,
			title         : language.changeEmail || 'Change Email',
			errSrcPath    : 'email.svg',
			role          : [ 'admin', 'superAdmin', 'employee', 'individual' ]
		}
	];

	const handleNavigate = (linkPath:any) =>
	{
		naviagte(`/profileSettings${linkPath}`);
	};

	return (
		<>
			<div className='flexRow hideScrollX customSideNavMob pdngVXS'>
				{PrflSettOpts?.map((each, index) =>
				{
					const activeNav =
							activePath === each.linkPath.split('/')[1] ? 'invertPrimary' : 'invertGray';
					const activeText =
							activePath === each.linkPath.split('/')[1] ? 'activeText' : '';
					const activeLink =
							activePath === each.linkPath.split('/')[1] ? 'activeLinkBrdrNone' : '';

					return (
						<div className={`flexInline pdngHXS ${!each?.role?.includes(userData?.role) && 'displayNone'}`} key={index}>
							<div className={`flexInline resNavLinkCustom whiteBg brdrRadiusXSM ${activeLink}`} onClick={() => handleNavigate(each.linkPath)}>
								<div className='flexAutoRow pdngHXS'>
									<div className={`resNavIcons ${activeNav} flexInline jusifyCntr alignCntr`}>
										{each.iconComponent
											? <each.iconComponent size={20} />
											: <img src={`${each.srcPath}`} className='fontIcons'/>
										}
									</div>
								</div>
								<div className='flexMinWidthCol pointer pdngRSM'>
									<span className={`resNavLinkTxt ${activeText} ellipsisTxt capitalTxt`}>
										{each.title}
									</span>
								</div>
							</div>
						</div>
					);
				}
				)}
			</div>
			<div className='flexCol whiteBg fullHeight customSideNavWeb brdrRSM'>
				<h2 className='mainHdngTxt pdngHMD'>{language.profileSettings}</h2>
				<div className='flexMinHeightCol scrollY'>
					<ul className={`flexMinHeightCol resSideNavGroup pdngVSM scrollXHidden ${isTouchDevice() ? 'scrollY' : 'scrollbarSideNav'}`}>
						<li className='flexCol resNavItem pointer'>
							{PrflSettOpts?.map((each, index) =>
							{
								const activeNav =
							activePath === each.linkPath.split('/')[1] ? 'invertPrimary' : 'invertGray';
								const activeText =
							activePath === each.linkPath.split('/')[1] ? 'activeText' : '';
								const activeLink =
							activePath === each.linkPath.split('/')[1] ? 'activeLink' : '';

								return (
									<div className={`flexRow alignCntr resNavLink ${activeLink} ${!each?.role?.includes(userData?.role) && 'displayNone'}`} key={index} onClick={() => handleNavigate(each.linkPath)}>
										<div className='flexAutoRow pdngHXS'>
											<div className={`resNavIcons ${activeNav} flexInline jusifyCntr alignCntr`}>
												{each.iconComponent
													? <each.iconComponent size={20} />
													: <img src={`${each.srcPath}`} className='fontIcons'/>
												}
											</div>
										</div>
										<div className='flexMinWidthRow pointer pdngRSM'>
											<span className={`resNavLinkTxt ${activeText} ellipsisTxt capitalTxt`}>
												{each.title}
											</span>
										</div>
										<div className={`flexAutoRow pointer ${activeText}`}>
											<RiArrowRightSLine/>
										</div>
									</div>
								);
							}
							)}
						</li>
					</ul>
				</div>
			</div>
		</>
	);
};

export default ProfileSettingsNav;